import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { TYPE_SP } from "../../common/defines";
import { openContactSelector } from "../../common/callUtil"
import { Link } from "../../lib/Link";
import { simulatorList, footerList } from "../../common/SimulatorList";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
const  lineuplist = require("../../data/asset/simulation.json").lineup;

export class Simulator extends React.Component {
  state = {};
  filterList = [];
  intersectionObserver;
  constructor(props, context) {
    super(props);
    this.context = context;
    this.filterList = this.createfilterList();
    this.state = this.getState(props, context);
  }

  getState(props, context) {
    const list = this.lineuplistFillter('all');
    const activeList = [];
    const selected = 'all';
    const opened = true
    const footerVisible = true;
    return {
      props,
      list,
      activeList,
      selected,
      opened,
      footerVisible
    }
  }

  createfilterList() {
    let list = []
    const categoryList = lineuplist.filter((val, index, self) => self.findIndex((value) => (val.category === value.category)) === index);
    
    // defaultValue
    list.push({
      key: '',
      text: 'すべて',
      value: 'all'})
    
    categoryList.map((val, index) =>  list.push({
      key: `${index}`,
      text: `${val.category}`,
      value: `${val.category}`})
    )
    return list

  }

  lineuplistFillter(key) {
    return key === 'all'  ? lineuplist : lineuplist.filter( val => val.category === key )
  }

  onItemListClick = (name, operator, activeList) => {
    const target = lineuplist.find(val => val.name === name)
    if (activeList.findIndex(val => val.name === target.name) === -1) {
      target.quantity = 1;
      const updatedList = activeList.slice()
      updatedList.push(target)
      updatedList.sort((a,b) => a.index < b.index ? -1 : 1)
      this.setState({activeList:updatedList})

    } else {
      const newValue = activeList.filter(val => val.name === name)[0]
      if (newValue.quantity === 1 && operator === 'minus') {
        const updatedList = activeList.filter(val => val.name !== target.name)
        this.setState({activeList:updatedList})
      } else if (operator === 'minus'){
        const updatedList = activeList.map(val => {if (val.name === name){ val.quantity--} return val})
        this.setState({activeList:updatedList})
      } else if (operator === 'plus') {
        const updatedList = activeList.map(val => {if (val.name === name){ val.quantity++} return val})
        console.log(updatedList)
        this.setState({activeList:updatedList})
      }
    }
  }

  calcBreadth (score) {
    if (score < 195) {
      return {min:0, max:1, extent: 1}
    } else if (195 <= score && score < 505) {
      return {min:1, max:2, extent: 2}
    } else if (505 <= score && score  < 685) {
      return {min:2, max:3, extent: 3}
    } else if (685 <= score && score < 1035) {
      return {min:3, max:4.5, extent: 4}
    } else if (1035 <= score && score < 2100) {
      return {min:4.5, max:8, extent: 5}
    } else if (2100 <= score) { 
      return {text:'お問い合わせください', extent: 'contact' }
    }
  }

  footerToggle(){
    this.setState({
      opened : !this.state.opened
    })
  }

  updateSelectValue(value) {
    console.log(this.state.selected);
    if (this.state.selected !== value) { 
      this.setState(
        {
          list:this.lineuplistFillter(value),
          selected: value
        }
      )
    }
  }

  resetSelectValue() {
    this.setState({activeList:[]});
  }

  startObserve() {
    this.intersectionObserver = new IntersectionObserver(entries => {
      const scroll = window.scrollY || window.pageYOffset
      this.setState({
        footerVisible: !entries.some(entry => entry.isIntersecting)
          && document.body.offsetHeight + scroll - 300 < document.querySelector('.simulator_bar_wrappper').offsetTop,
      })
    });
    this.intersectionObserver.POLL_INTERVAL = 100;
    this.intersectionObserver.observe(document.querySelector('.information_wrap'));
  }

  componentDidMount() {
    this.startObserve();
  }
  
  render() {
    const list = simulatorList(this.state.list, this.state.activeList, this.onItemListClick)
    const fooderList = footerList(this.state.activeList, this.onItemListClick)
    const breadth = this.calcBreadth(this.state.activeList.length > 0 ? this.state.activeList.map( val => val.score * val.quantity ).reduce((prev, current) => prev + current) : 0)
    const linkUrl = `/list/?extent=${breadth.extent}`
    const footerClass = this.state.opened ? 'simulator_bar_item open' : 'simulator_bar_item'
    const imageUrl = `resource/img/static/simulator/modal${this.props.type === TYPE_SP ? '' : '3x'}.png`
    const footerHeight = document.querySelector('.simulator_bar') ? document.querySelector('.simulator_bar').clientHeight : 0

    let breadthElement;
    if ( (typeof breadth.text) === 'string' ) {
      breadthElement = <div>{breadth.text}</div>;
    } else {
      if ( breadth.min === 0 ) {
        breadthElement = <div><span>お部屋の目安</span><strong>{breadth.max}</strong>帖未満</div>;
      } else {
        breadthElement = <div><span>お部屋の目安</span><strong>{breadth.min}</strong>帖〜<strong>{breadth.max}</strong>帖未満</div>;
      }
    }
    
    const contactElement = this.props.type === TYPE_SP ? <div className="contact" onClick={(e) => { e.preventDefault(); openContactSelector({ eventTrackingId: 'tel_action_header_sp' });}}>お問い合わせ</div> 
                                                       : <a className="contact" onClick={() => openContactSelector({ eventTrackingId: 'tel_action_header_pc' })}>お問い合わせ</a>

    this.createfilterList()

    return (
      <div className="container">
        {breadcrumbs(this.state.type, [{ text: "収納シミュレーション" }])}
        <div className="simulator">
          <div className="title_content">
            <div className="container">
              <p className="simulator_title">収納シミュレーション</p>
              <p className="simulator_text">収納物を選んでお部屋サイズを見てみよう！</p>
            </div>
          </div>
          <section className="container">
            <div className="content_inner">
              <div className="simulator_content_header">
                <div className="select_wrap">
                  <label className="label">用途から絞り込む</label>
                  <Dropdown
                    className="simulator_select"
                    defaultValue={this.state.selected}
                    value={this.state.selected}
                    options={this.filterList}
                    onChange={(event, element) => {
                      this.updateSelectValue(element.value);
                    }}
                  />
                </div>
                <div className="howto" onClick={() => modal.openModal("modal_simulator", { imageUrl })}>
                  <span className="howto_text">使い方</span>
                  <a
                    className="howto_icon"
                    onClick={() => modal.openModal("modal_simulator")}
                  >
                    <img
                      src="resource/img/static/simulator/icon_howto.png"
                      alt="?"
                    />
                  </a>
                </div>
              </div>
              <ul className="simulator_list">
                {list}
              </ul>
            </div>
          </section>
          <div className="simulator_bar_wrappper" style={{height: `${footerHeight}px`}}>
          <div className="simulator_bar" style={{position: this.state.footerVisible ? 'fixed' : 'relative'}}>
            <div className={footerClass}>
              <div className="anchor_toggle" onClick={ () => this.footerToggle()} style={{zIndex: this.state.footerVisible ? '' : -1}}></div>
              <div className="container">
                <ul className="simulator_item_list">
                  {fooderList}
                </ul>
              </div>
            </div>
            <div className="dspfx container cf">
              <div className="simulator_detail">
                <div className="count">
                  収納点数
                  <strong>{this.state.activeList.length > 0 ? this.state.activeList.map( val => val.quantity ).reduce((prev, current) => prev + current) : 0 }</strong>
                  点
                </div>
                <img src="resource/img/static/simulator/icon_arrow.png" />
                <div className="breadth">
                {breadthElement}
                </div>
              </div>
              <ul className="simulator_btn_area">
                <li>
                  <div className="reset_btn" onClick={() => this.resetSelectValue()}>
                    リセット
                  </div>
                </li>
                <li>{ (typeof breadth.extent === 'string') ?
                  contactElement
                  :
                  <Link to={linkUrl} className="search_btn">
                    このサイズの物件を探す
                  </Link>
                  }
                </li>
              </ul>
            </div>
          </div>
          </div>
          <div className="information_wrap">
            <div className="container">
              <div className="information">
                <div className="pc">
                  <Link to="/lineup/" className="textArea">
                    <img src="resource/img/static/beginner/lineup.png" />
                    <span>
                      商品ラインナップは
                      <br />
                      こちら
                    </span>
                  </Link>
                  <Link to="/flow/" className="textArea">
                    <img src="resource/img/static/beginner/flow.png" />
                    <span>
                      お申し込みから
                      <br />
                      ご契約の流れまで
                    </span>
                  </Link>
                  <Link to="/voice2/" className="textArea">
                    <img src="resource/img/static/beginner/voice.png" />
                    <span>
                      実際の
                      <br />
                      お客様の声
                    </span>
                  </Link>
                </div>
                <div className="sp">
                  <Link to="/lineup/" className="text1">
                    <img src="resource/img/static/beginner/lineup_sp.png" />
                    <span>
                      商品ラインナップは
                      <br />
                      こちら
                    </span>
                  </Link>
                  <Link to="/flow/" className="text2">
                    <img src="resource/img/static/beginner/flow_sp.png" />
                    <span>
                      お申し込みから
                      <br />
                      ご契約の流れまで
                    </span>
                  </Link>
                  <Link to="/voice2/" className="text3">
                    <img src="resource/img/static/beginner/voice_sp.png" />
                    <span>
                      実際の
                      <br />
                      お客様の声
                    </span>
                  </Link>
                </div>
                <br className="left" />
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  };
};



// WEBPACK FOOTER //
// ./pages/new/simulator.jsx